export default "__VITE_ASSET__47cd4dc6__"